// // // // (() => {
// // // //   // ========= CONFIG =========
// // // //   const CATEGORY_GROUP_SELECTOR = '.custom-facets__pills[data-filter-label="Category"]';
// // // //   const PILL_SELECTOR = '.custom-facet-pill';
// // // //   const CLEAR_PILL_SELECTOR = '.custom-facet-pill--clear, .custom-facet-pill[data-clear="true"]';
// // // //   const MONTH_SELECT_SELECTOR = '#CustomMonthSelect';
// // // //   const DRAWER_SELECTOR = 'facet-drawer#FacetDrawer';

// // // //   const CATEGORY_PARAM = 'filter.p.m.custom.categry';
// // // //   const MONTH_PARAM_FALLBACK = 'filter.p.m.custom.months';
// // // //   const ACTIVE_CLASS = 'is-active';

// // // //   const qs = (s, r = document) => r.querySelector(s);
// // // //   const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
// // // //   const drawer = qs(DRAWER_SELECTOR) || document;

// // // //   const esc = (v) => (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, '\\$&');

// // // //   // ========= Helpers =========
// // // //   function clickLikeUser(cb) {
// // // //     if (!cb) return;
// // // //     const label = cb.id ? document.querySelector(`label[for="${esc(cb.id)}"]`) : null;
// // // //     (label || cb).click();
// // // //   }

// // // //   function findCheckbox(name, value) {
// // // //     const sel = `input[type="checkbox"][name="${esc(name)}"][value="${esc(value)}"]`;
// // // //     return drawer.querySelector(sel) || document.querySelector(sel);
// // // //   }

// // // //   function getCheckboxes(name) {
// // // //     return qsa(`input[type="checkbox"][name="${esc(name)}"]`, document);
// // // //   }

// // // //   function getCheckedValue(name) {
// // // //     const checked = getCheckboxes(name).find(cb => cb.checked);
// // // //     return checked ? checked.value : null;
// // // //   }

// // // //   function clearFacet(name) {
// // // //     getCheckboxes(name).forEach(cb => {
// // // //       if (cb.checked) clickLikeUser(cb);
// // // //     });
// // // //   }

// // // //   // ========= UI Sync =========
// // // //   function syncCategoryPillsFromFacetState() {
// // // //     const group = qs(CATEGORY_GROUP_SELECTOR);
// // // //     if (!group) return;

// // // //     const pills = qsa(PILL_SELECTOR, group).filter(p => !p.matches(CLEAR_PILL_SELECTOR));
// // // //     const clearBtn = qs(CLEAR_PILL_SELECTOR, group);

// // // //     const checkedValue = getCheckedValue(CATEGORY_PARAM);

// // // //     pills.forEach(pill => {
// // // //       const val = pill.dataset.value;
// // // //       const isOn = !!checkedValue && val === checkedValue;
// // // //       pill.classList.toggle(ACTIVE_CLASS, isOn);
// // // //       pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
// // // //     });

// // // //     if (clearBtn) {
// // // //       const showAllActive = !checkedValue;
// // // //       clearBtn.classList.toggle(ACTIVE_CLASS, showAllActive);
// // // //       clearBtn.setAttribute('aria-pressed', showAllActive ? 'true' : 'false');
// // // //     }
// // // //   }

// // // //   function scheduleSync() {
// // // //     setTimeout(syncCategoryPillsFromFacetState, 50);
// // // //     setTimeout(syncCategoryPillsFromFacetState, 200);
// // // //   }

// // // //   // ========= Single-select CATEGORY (robust) =========
// // // //   function setSingleCategoryValue(nextValueOrNull) {
// // // //     const currentValue = getCheckedValue(CATEGORY_PARAM);

// // // //     // If user clicked the currently selected value => clear (Show all)
// // // //     if (currentValue && nextValueOrNull === currentValue) {
// // // //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// // // //       if (currentCb) clickLikeUser(currentCb);
// // // //       scheduleSync();
// // // //       return;
// // // //     }

// // // //     // If something is selected, turn it off (ONLY that one)
// // // //     if (currentValue) {
// // // //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// // // //       if (currentCb) clickLikeUser(currentCb);
// // // //     }

// // // //     // If we want "Show all" => done
// // // //     if (!nextValueOrNull) {
// // // //       scheduleSync();
// // // //       return;
// // // //     }

// // // //     // IMPORTANT: wait a tick so Shopify can re-render after unchecking,
// // // //     // then re-find and click the new checkbox in the updated DOM.
// // // //     setTimeout(() => {
// // // //       const nextCb = findCheckbox(CATEGORY_PARAM, nextValueOrNull);
// // // //       if (nextCb) {
// // // //         clickLikeUser(nextCb);
// // // //       } else {
// // // //         // If we can't find it, at least don't leave it cleared silently:
// // // //         console.warn('[FacetSingle] Could not find next checkbox', {
// // // //           name: CATEGORY_PARAM,
// // // //           value: nextValueOrNull
// // // //         });
// // // //       }
// // // //       scheduleSync();
// // // //     }, 80);
// // // //   }

// // // //   // ========= Click handling (CATEGORY pills) =========
// // // //   document.addEventListener('click', (e) => {
// // // //     const pill = e.target.closest(PILL_SELECTOR);
// // // //     if (!pill) return;

// // // //     const group = pill.closest(CATEGORY_GROUP_SELECTOR);
// // // //     if (!group) return;

// // // //     if (pill.matches(CLEAR_PILL_SELECTOR)) {
// // // //       setSingleCategoryValue(null);
// // // //       return;
// // // //     }

// // // //     const value = pill.dataset.value;
// // // //     setSingleCategoryValue(value);
// // // //   }, true);

// // // //   // ========= Month dropdown (single-select) =========
// // // //   function setSingleFacetValue(name, valueOrNull) {
// // // //     // clear all first is OK for months; but to be safe, we can do the same robust approach:
// // // //     const current = getCheckboxes(name).find(cb => cb.checked)?.value || null;

// // // //     if (current && valueOrNull === current) return; // no change

// // // //     if (current) {
// // // //       const currentCb = findCheckbox(name, current);
// // // //       if (currentCb) clickLikeUser(currentCb);
// // // //     }

// // // //     if (!valueOrNull) return;

// // // //     setTimeout(() => {
// // // //       const nextCb = findCheckbox(name, valueOrNull);
// // // //       if (nextCb) clickLikeUser(nextCb);
// // // //     }, 80);
// // // //   }

// // // //   document.addEventListener('change', (e) => {
// // // //     const select = e.target.closest(MONTH_SELECT_SELECTOR);
// // // //     if (!select) return;

// // // //     const opt = select.selectedOptions?.[0];
// // // //     const monthParam = opt?.dataset?.paramName || MONTH_PARAM_FALLBACK;
// // // //     const value = select.value || null;

// // // //     setSingleFacetValue(monthParam, value);
// // // //   }, true);

// // // //   // ========= Initial + keep-in-sync =========
// // // //   syncCategoryPillsFromFacetState();

// // // //   const obsRoot = qs('#ProductGridContainer') || document.body;
// // // //   const mo = new MutationObserver(() => scheduleSync());
// // // //   mo.observe(obsRoot, { childList: true, subtree: true });
// // // // })();


// // // (() => {
// // //   // ========= CONFIG =========
// // //   const CATEGORY_GROUP_SELECTOR = '.custom-facets__pills[data-filter-label="Category"]';
// // //   const PILL_SELECTOR = '.custom-facet-pill';
// // //   const CLEAR_PILL_SELECTOR = '.custom-facet-pill--clear, .custom-facet-pill[data-clear="true"]';

// // //   const MONTH_SELECT_SELECTOR = '#CustomMonthSelect';
// // //   const MONTHS_JSON_SELECTOR = '#MonthsFacetValuesJSON';

// // //   const DRAWER_SELECTOR = 'facet-drawer#FacetDrawer';

// // //   const CATEGORY_PARAM = 'filter.p.m.custom.categry';
// // //   const MONTH_PARAM_FALLBACK = 'filter.p.m.custom.months';

// // //   const ACTIVE_CLASS = 'is-active';

// // //   const qs = (s, r = document) => r.querySelector(s);
// // //   const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
// // //   const drawer = qs(DRAWER_SELECTOR) || document;

// // //   const esc = (v) =>
// // //     (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, '\\$&');

// // //   // ========= Helpers =========
// // //   function clickLikeUser(cb) {
// // //     if (!cb) return;
// // //     const label = cb.id ? document.querySelector(`label[for="${esc(cb.id)}"]`) : null;
// // //     (label || cb).click();
// // //   }

// // //   function findCheckbox(name, value) {
// // //     const sel = `input[type="checkbox"][name="${esc(name)}"][value="${esc(value)}"]`;
// // //     return drawer.querySelector(sel) || document.querySelector(sel);
// // //   }

// // //   function getCheckboxes(name) {
// // //     return qsa(`input[type="checkbox"][name="${esc(name)}"]`, document);
// // //   }

// // //   function getCheckedValues(name) {
// // //     return getCheckboxes(name).filter(cb => cb.checked).map(cb => cb.value);
// // //   }

// // //   function getCheckedValue(name) {
// // //     const checked = getCheckboxes(name).find(cb => cb.checked);
// // //     return checked ? checked.value : null;
// // //   }

// // //   // ========= UI Sync (Category) =========
// // //   function syncCategoryPillsFromFacetState() {
// // //     const group = qs(CATEGORY_GROUP_SELECTOR);
// // //     if (!group) return;

// // //     const pills = qsa(PILL_SELECTOR, group).filter(p => !p.matches(CLEAR_PILL_SELECTOR));
// // //     const clearBtn = qs(CLEAR_PILL_SELECTOR, group);

// // //     const checkedValue = getCheckedValue(CATEGORY_PARAM);

// // //     pills.forEach(pill => {
// // //       const val = pill.dataset.value;
// // //       const isOn = !!checkedValue && val === checkedValue;
// // //       pill.classList.toggle(ACTIVE_CLASS, isOn);
// // //       pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
// // //     });

// // //     if (clearBtn) {
// // //       const showAllActive = !checkedValue;
// // //       clearBtn.classList.toggle(ACTIVE_CLASS, showAllActive);
// // //       clearBtn.setAttribute('aria-pressed', showAllActive ? 'true' : 'false');
// // //     }
// // //   }

// // //   function scheduleSync() {
// // //     setTimeout(syncCategoryPillsFromFacetState, 50);
// // //     setTimeout(syncCategoryPillsFromFacetState, 200);
// // //     setTimeout(syncMonthSelectFromFacetState, 80);
// // //     setTimeout(syncMonthSelectFromFacetState, 250);
// // //   }

// // //   // ========= Single-select CATEGORY (robust) =========
// // //   function setSingleCategoryValue(nextValueOrNull) {
// // //     const currentValue = getCheckedValue(CATEGORY_PARAM);

// // //     if (currentValue && nextValueOrNull === currentValue) {
// // //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// // //       if (currentCb) clickLikeUser(currentCb);
// // //       scheduleSync();
// // //       return;
// // //     }

// // //     if (currentValue) {
// // //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// // //       if (currentCb) clickLikeUser(currentCb);
// // //     }

// // //     if (!nextValueOrNull) {
// // //       scheduleSync();
// // //       return;
// // //     }

// // //     setTimeout(() => {
// // //       const nextCb = findCheckbox(CATEGORY_PARAM, nextValueOrNull);
// // //       if (nextCb) clickLikeUser(nextCb);
// // //       scheduleSync();
// // //     }, 80);
// // //   }

// // //   document.addEventListener('click', (e) => {
// // //     const pill = e.target.closest(PILL_SELECTOR);
// // //     if (!pill) return;

// // //     const group = pill.closest(CATEGORY_GROUP_SELECTOR);
// // //     if (!group) return;

// // //     if (pill.matches(CLEAR_PILL_SELECTOR)) {
// // //       setSingleCategoryValue(null);
// // //       return;
// // //     }

// // //     setSingleCategoryValue(pill.dataset.value);
// // //   }, true);

// // //   // ==========================================================
// // //   // ===================== MONTH GROUPING ======================
// // //   // ==========================================================

// // //   const MONTHS = {
// // //     jan: 0, january: 0,
// // //     feb: 1, february: 1,
// // //     mar: 2, march: 2,
// // //     apr: 3, april: 3,
// // //     may: 4,
// // //     jun: 5, june: 5,
// // //     jul: 6, july: 6,
// // //     aug: 7, august: 7,
// // //     sep: 8, sept: 8, september: 8,
// // //     oct: 9, october: 9,
// // //     nov: 10, november: 10,
// // //     dec: 11, december: 11,
// // //   };
// // //   const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

// // //   function parseMonthYearFromLabel(label) {
// // //     // Examples:
// // //     // "Apr 26, 2026"
// // //     // "Apr 12 - 13, 2026"
// // //     // "June 2026"
// // //     // "May 10"   (no year => current year)
// // //     // "feb 13-23"
// // //     const s = String(label || '').trim();
// // //     if (!s) return null;

// // //     // find month word (first word usually)
// // //     const m = s.match(/([A-Za-z]{3,9})/);
// // //     if (!m) return null;

// // //     const monthWord = m[1].toLowerCase();
// // //     const monthIdx = MONTHS[monthWord];
// // //     if (monthIdx === undefined) return null;

// // //     // find 4-digit year if any
// // //     const y = s.match(/\b(20\d{2}|19\d{2})\b/);
// // //     const year = y ? parseInt(y[1], 10) : (new Date()).getFullYear();

// // //     return { monthIdx, year };
// // //   }

// // //   function monthKey({ monthIdx, year }) {
// // //     return `${year}-${String(monthIdx + 1).padStart(2, '0')}`; // 2026-02
// // //   }

// // //   function monthLabel({ monthIdx, year }) {
// // //     return `${MONTH_NAMES[monthIdx]} ${year}`; // Feb 2026
// // //   }

// // //   function readMonthsFacetValues() {
// // //     const el = qs(MONTHS_JSON_SELECTOR);
// // //     if (!el) return [];
// // //     try {
// // //       const arr = JSON.parse(el.textContent || '[]');
// // //       return Array.isArray(arr) ? arr : [];
// // //     } catch (e) {
// // //       console.warn('[Months] JSON parse failed', e);
// // //       return [];
// // //     }
// // //   }

// // //   // Map: monthKey -> {label, year, monthIdx, items:[facetValueObjects], totalCount, anyActive, allDisabled}
// // //   let monthGroups = new Map();

// // //   function buildMonthGroups() {
// // //     const values = readMonthsFacetValues();
// // //     const groups = new Map();

// // //     values.forEach(v => {
// // //       const p = parseMonthYearFromLabel(v.label);
// // //       if (!p) return;

// // //       const key = monthKey(p);
// // //       if (!groups.has(key)) {
// // //         groups.set(key, {
// // //           key,
// // //           monthIdx: p.monthIdx,
// // //           year: p.year,
// // //           label: monthLabel(p),
// // //           items: [],
// // //           totalCount: 0,
// // //           anyActive: false,
// // //           allDisabled: true
// // //         });
// // //       }
// // //       const g = groups.get(key);
// // //       g.items.push(v);
// // //       g.totalCount += Number(v.count || 0);
// // //       g.anyActive = g.anyActive || !!v.active;
// // //       g.allDisabled = g.allDisabled && !!v.disabled;
// // //     });

// // //     // Sort by year then month
// // //     monthGroups = new Map(
// // //       Array.from(groups.entries()).sort((a, b) => {
// // //         const ga = a[1], gb = b[1];
// // //         if (ga.year !== gb.year) return ga.year - gb.year;
// // //         return ga.monthIdx - gb.monthIdx;
// // //       })
// // //     );
// // //   }

// // //   function renderMonthSelectOptions() {
// // //     const select = qs(MONTH_SELECT_SELECTOR);
// // //     if (!select) return;

// // //     // Keep the first "All months" option, clear the rest
// // //     const allOpt = select.querySelector('option[value=""]');
// // //     select.innerHTML = '';
// // //     if (allOpt) {
// // //       select.appendChild(allOpt);
// // //     } else {
// // //       const o = document.createElement('option');
// // //       o.value = '';
// // //       o.textContent = 'All months';
// // //       select.appendChild(o);
// // //     }

// // //     for (const [, g] of monthGroups) {
// // //       const opt = document.createElement('option');
// // //       opt.value = g.key;                 // <-- group key like 2026-02
// // //       opt.dataset.groupKey = g.key;
// // //       opt.textContent = `${g.label} (${g.totalCount})`;
// // //       if (g.allDisabled && !g.anyActive) opt.disabled = true;
// // //       select.appendChild(opt);
// // //     }
// // //   }

// // //   function getMonthParamNameFromData() {
// // //     const select = qs(MONTH_SELECT_SELECTOR);
// // //     const fromSelect = select?.dataset?.paramName;
// // //     return fromSelect || MONTH_PARAM_FALLBACK;
// // //   }

// // //   // Apply multi-select month group:
// // //   // - Uncheck all currently checked months facet values
// // //   // - Check all facet values belonging to the selected group key
// // //   function applyMonthGroup(groupKeyOrNull) {
// // //     const paramName = getMonthParamNameFromData();

// // //     // Clear current (all checked)
// // //     const checked = getCheckedValues(paramName);
// // //     checked.forEach(val => {
// // //       const cb = findCheckbox(paramName, val);
// // //       if (cb) clickLikeUser(cb);
// // //     });

// // //     if (!groupKeyOrNull) {
// // //       scheduleSync();
// // //       return;
// // //     }

// // //     const group = monthGroups.get(groupKeyOrNull);
// // //     if (!group) {
// // //       console.warn('[Months] Unknown group key', groupKeyOrNull);
// // //       scheduleSync();
// // //       return;
// // //     }

// // //     // Wait for re-render after clearing, then click all items in this month
// // //     setTimeout(() => {
// // //       group.items.forEach(item => {
// // //         const cb = findCheckbox(item.param_name || paramName, item.value);
// // //         if (cb && !cb.checked) clickLikeUser(cb);
// // //       });
// // //       scheduleSync();
// // //     }, 120);
// // //   }

// // //   function syncMonthSelectFromFacetState() {
// // //     const select = qs(MONTH_SELECT_SELECTOR);
// // //     if (!select) return;

// // //     const paramName = getMonthParamNameFromData();
// // //     const checkedVals = new Set(getCheckedValues(paramName));

// // //     // Determine which group is "active":
// // //     // If any checked facet value belongs to a month group, select that group.
// // //     // If multiple months are checked (possible), we’ll select blank (All months).
// // //     let activeGroupKey = null;
// // //     let activeCount = 0;

// // //     for (const [, g] of monthGroups) {
// // //       const anyCheckedInGroup = g.items.some(it => checkedVals.has(it.value));
// // //       if (anyCheckedInGroup) {
// // //         activeGroupKey = g.key;
// // //         activeCount++;
// // //         if (activeCount > 1) break;
// // //       }
// // //     }

// // //     select.value = (activeCount === 1) ? activeGroupKey : '';
// // //   }

// // //   document.addEventListener('change', (e) => {
// // //     const select = e.target.closest(MONTH_SELECT_SELECTOR);
// // //     if (!select) return;

// // //     const groupKey = select.value || null; // e.g. "2026-02" or null
// // //     applyMonthGroup(groupKey);
// // //   }, true);

// // //   // ========= Init =========
// // //   syncCategoryPillsFromFacetState();

// // //   // Build months list from available values, then render grouped options
// // //   buildMonthGroups();
// // //   renderMonthSelectOptions();
// // //   syncMonthSelectFromFacetState();

// // //   // Rebuild months groups on grid changes (facets update)
// // //   const obsRoot = qs('#ProductGridContainer') || document.body;
// // //   const mo = new MutationObserver(() => {
// // //     // Month values/counts/active can change after filtering; rebuild from JSON if it got re-rendered
// // //     buildMonthGroups();
// // //     renderMonthSelectOptions();
// // //     scheduleSync();
// // //   });
// // //   mo.observe(obsRoot, { childList: true, subtree: true });
// // // })();



// // // (() => {
// // //   // ========= CONFIG =========
// // //   const CATEGORY_GROUP_SELECTOR = '.custom-facets__pills[data-filter-label="Category"]';
// // //   const PILL_SELECTOR = '.custom-facet-pill';
// // //   const CLEAR_PILL_SELECTOR = '.custom-facet-pill--clear, .custom-facet-pill[data-clear="true"]';
// // //   const MONTH_SELECT_SELECTOR = '#CustomMonthSelect';
// // //   const DRAWER_SELECTOR = 'facet-drawer#FacetDrawer';

// // //   const CATEGORY_PARAM = 'filter.p.m.custom.categry';
// // //   const MONTH_PARAM_FALLBACK = 'filter.p.m.custom.months';
// // //   const ACTIVE_CLASS = 'is-active';

// // //   const qs = (s, r = document) => r.querySelector(s);
// // //   const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
// // //   const drawer = qs(DRAWER_SELECTOR) || document;

// // //   const esc = (v) => (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, '\\$&');

// // //   // ========= Helpers =========
// // //   function clickLikeUser(cb) {
// // //     if (!cb) return;
// // //     const label = cb.id ? document.querySelector(`label[for="${esc(cb.id)}"]`) : null;
// // //     (label || cb).click();
// // //   }

// // //   function findCheckbox(name, value) {
// // //     const sel = `input[type="checkbox"][name="${esc(name)}"][value="${esc(value)}"]`;
// // //     return drawer.querySelector(sel) || document.querySelector(sel);
// // //   }

// // //   function getCheckboxes(name) {
// // //     return qsa(`input[type="checkbox"][name="${esc(name)}"]`, document);
// // //   }

// // //   function getCheckedValue(name) {
// // //     const checked = getCheckboxes(name).find(cb => cb.checked);
// // //     return checked ? checked.value : null;
// // //   }

// // //   function clearFacet(name) {
// // //     getCheckboxes(name).forEach(cb => {
// // //       if (cb.checked) clickLikeUser(cb);
// // //     });
// // //   }

// // //   // ========= UI Sync =========
// // //   function syncCategoryPillsFromFacetState() {
// // //     const group = qs(CATEGORY_GROUP_SELECTOR);
// // //     if (!group) return;

// // //     const pills = qsa(PILL_SELECTOR, group).filter(p => !p.matches(CLEAR_PILL_SELECTOR));
// // //     const clearBtn = qs(CLEAR_PILL_SELECTOR, group);

// // //     const checkedValue = getCheckedValue(CATEGORY_PARAM);

// // //     pills.forEach(pill => {
// // //       const val = pill.dataset.value;
// // //       const isOn = !!checkedValue && val === checkedValue;
// // //       pill.classList.toggle(ACTIVE_CLASS, isOn);
// // //       pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
// // //     });

// // //     if (clearBtn) {
// // //       const showAllActive = !checkedValue;
// // //       clearBtn.classList.toggle(ACTIVE_CLASS, showAllActive);
// // //       clearBtn.setAttribute('aria-pressed', showAllActive ? 'true' : 'false');
// // //     }
// // //   }

// // //   function scheduleSync() {
// // //     setTimeout(syncCategoryPillsFromFacetState, 50);
// // //     setTimeout(syncCategoryPillsFromFacetState, 200);
// // //   }

// // //   // ========= Single-select CATEGORY (robust) =========
// // //   function setSingleCategoryValue(nextValueOrNull) {
// // //     const currentValue = getCheckedValue(CATEGORY_PARAM);

// // //     // If user clicked the currently selected value => clear (Show all)
// // //     if (currentValue && nextValueOrNull === currentValue) {
// // //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// // //       if (currentCb) clickLikeUser(currentCb);
// // //       scheduleSync();
// // //       return;
// // //     }

// // //     // If something is selected, turn it off (ONLY that one)
// // //     if (currentValue) {
// // //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// // //       if (currentCb) clickLikeUser(currentCb);
// // //     }

// // //     // If we want "Show all" => done
// // //     if (!nextValueOrNull) {
// // //       scheduleSync();
// // //       return;
// // //     }

// // //     // IMPORTANT: wait a tick so Shopify can re-render after unchecking,
// // //     // then re-find and click the new checkbox in the updated DOM.
// // //     setTimeout(() => {
// // //       const nextCb = findCheckbox(CATEGORY_PARAM, nextValueOrNull);
// // //       if (nextCb) {
// // //         clickLikeUser(nextCb);
// // //       } else {
// // //         // If we can't find it, at least don't leave it cleared silently:
// // //         console.warn('[FacetSingle] Could not find next checkbox', {
// // //           name: CATEGORY_PARAM,
// // //           value: nextValueOrNull
// // //         });
// // //       }
// // //       scheduleSync();
// // //     }, 80);
// // //   }

// // //   // ========= Click handling (CATEGORY pills) =========
// // //   document.addEventListener('click', (e) => {
// // //     const pill = e.target.closest(PILL_SELECTOR);
// // //     if (!pill) return;

// // //     const group = pill.closest(CATEGORY_GROUP_SELECTOR);
// // //     if (!group) return;

// // //     if (pill.matches(CLEAR_PILL_SELECTOR)) {
// // //       setSingleCategoryValue(null);
// // //       return;
// // //     }

// // //     const value = pill.dataset.value;
// // //     setSingleCategoryValue(value);
// // //   }, true);

// // //   // ========= Month dropdown (single-select) =========
// // //   function setSingleFacetValue(name, valueOrNull) {
// // //     // clear all first is OK for months; but to be safe, we can do the same robust approach:
// // //     const current = getCheckboxes(name).find(cb => cb.checked)?.value || null;

// // //     if (current && valueOrNull === current) return; // no change

// // //     if (current) {
// // //       const currentCb = findCheckbox(name, current);
// // //       if (currentCb) clickLikeUser(currentCb);
// // //     }

// // //     if (!valueOrNull) return;

// // //     setTimeout(() => {
// // //       const nextCb = findCheckbox(name, valueOrNull);
// // //       if (nextCb) clickLikeUser(nextCb);
// // //     }, 80);
// // //   }

// // //   document.addEventListener('change', (e) => {
// // //     const select = e.target.closest(MONTH_SELECT_SELECTOR);
// // //     if (!select) return;

// // //     const opt = select.selectedOptions?.[0];
// // //     const monthParam = opt?.dataset?.paramName || MONTH_PARAM_FALLBACK;
// // //     const value = select.value || null;

// // //     setSingleFacetValue(monthParam, value);
// // //   }, true);

// // //   // ========= Initial + keep-in-sync =========
// // //   syncCategoryPillsFromFacetState();

// // //   const obsRoot = qs('#ProductGridContainer') || document.body;
// // //   const mo = new MutationObserver(() => scheduleSync());
// // //   mo.observe(obsRoot, { childList: true, subtree: true });
// // // })();


// // (() => {
// //   // ========= CONFIG =========
// //   const CATEGORY_GROUP_SELECTOR = '.custom-facets__pills[data-filter-label="Category"]';
// //   const PILL_SELECTOR = '.custom-facet-pill';
// //   const CLEAR_PILL_SELECTOR = '.custom-facet-pill--clear, .custom-facet-pill[data-clear="true"]';

// //   const MONTH_SELECT_SELECTOR = '#CustomMonthSelect';
// //   const MONTHS_JSON_SELECTOR = '#MonthsFacetValuesJSON';

// //   const DRAWER_SELECTOR = 'facet-drawer#FacetDrawer';

// //   const CATEGORY_PARAM = 'filter.p.m.custom.categry';
// //   const MONTH_PARAM_FALLBACK = 'filter.p.m.custom.months';

// //   const ACTIVE_CLASS = 'is-active';

// //   const qs = (s, r = document) => r.querySelector(s);
// //   const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
// //   const drawer = qs(DRAWER_SELECTOR) || document;

// //   const esc = (v) =>
// //     (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, '\\$&');

// //   // ========= Helpers =========
// //   function clickLikeUser(cb) {
// //     if (!cb) return;
// //     const label = cb.id ? document.querySelector(`label[for="${esc(cb.id)}"]`) : null;
// //     (label || cb).click();
// //   }

// //   function findCheckbox(name, value) {
// //     const sel = `input[type="checkbox"][name="${esc(name)}"][value="${esc(value)}"]`;
// //     return drawer.querySelector(sel) || document.querySelector(sel);
// //   }

// //   function getCheckboxes(name) {
// //     return qsa(`input[type="checkbox"][name="${esc(name)}"]`, document);
// //   }

// //   function getCheckedValues(name) {
// //     return getCheckboxes(name).filter(cb => cb.checked).map(cb => cb.value);
// //   }

// //   function getCheckedValue(name) {
// //     const checked = getCheckboxes(name).find(cb => cb.checked);
// //     return checked ? checked.value : null;
// //   }

// //   // ========= UI Sync (Category) =========
// //   function syncCategoryPillsFromFacetState() {
// //     const group = qs(CATEGORY_GROUP_SELECTOR);
// //     if (!group) return;

// //     const pills = qsa(PILL_SELECTOR, group).filter(p => !p.matches(CLEAR_PILL_SELECTOR));
// //     const clearBtn = qs(CLEAR_PILL_SELECTOR, group);

// //     const checkedValue = getCheckedValue(CATEGORY_PARAM);

// //     pills.forEach(pill => {
// //       const val = pill.dataset.value;
// //       const isOn = !!checkedValue && val === checkedValue;
// //       pill.classList.toggle(ACTIVE_CLASS, isOn);
// //       pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
// //     });

// //     if (clearBtn) {
// //       const showAllActive = !checkedValue;
// //       clearBtn.classList.toggle(ACTIVE_CLASS, showAllActive);
// //       clearBtn.setAttribute('aria-pressed', showAllActive ? 'true' : 'false');
// //     }
// //   }

// //   function scheduleSync() {
// //     setTimeout(syncCategoryPillsFromFacetState, 50);
// //     setTimeout(syncCategoryPillsFromFacetState, 200);
// //     setTimeout(syncMonthSelectFromFacetState, 80);
// //     setTimeout(syncMonthSelectFromFacetState, 250);
// //   }

// //   // ========= Single-select CATEGORY (robust) =========
// //   function setSingleCategoryValue(nextValueOrNull) {
// //     const currentValue = getCheckedValue(CATEGORY_PARAM);

// //     if (currentValue && nextValueOrNull === currentValue) {
// //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// //       if (currentCb) clickLikeUser(currentCb);
// //       scheduleSync();
// //       return;
// //     }

// //     if (currentValue) {
// //       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
// //       if (currentCb) clickLikeUser(currentCb);
// //     }

// //     if (!nextValueOrNull) {
// //       scheduleSync();
// //       return;
// //     }

// //     setTimeout(() => {
// //       const nextCb = findCheckbox(CATEGORY_PARAM, nextValueOrNull);
// //       if (nextCb) clickLikeUser(nextCb);
// //       scheduleSync();
// //     }, 80);
// //   }

// //   document.addEventListener('click', (e) => {
// //     const pill = e.target.closest(PILL_SELECTOR);
// //     if (!pill) return;

// //     const group = pill.closest(CATEGORY_GROUP_SELECTOR);
// //     if (!group) return;

// //     if (pill.matches(CLEAR_PILL_SELECTOR)) {
// //       setSingleCategoryValue(null);
// //       return;
// //     }

// //     setSingleCategoryValue(pill.dataset.value);
// //   }, true);

// //   // ==========================================================
// //   // ===================== MONTH GROUPING ======================
// //   // ==========================================================

// //   const MONTHS = {
// //     jan: 0, january: 0,
// //     feb: 1, february: 1,
// //     mar: 2, march: 2,
// //     apr: 3, april: 3,
// //     may: 4,
// //     jun: 5, june: 5,
// //     jul: 6, july: 6,
// //     aug: 7, august: 7,
// //     sep: 8, sept: 8, september: 8,
// //     oct: 9, october: 9,
// //     nov: 10, november: 10,
// //     dec: 11, december: 11,
// //   };
// //   const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

// //   function parseMonthYearFromLabel(label) {
// //     // Examples:
// //     // "Apr 26, 2026"
// //     // "Apr 12 - 13, 2026"
// //     // "June 2026"
// //     // "May 10"   (no year => current year)
// //     // "feb 13-23"
// //     const s = String(label || '').trim();
// //     if (!s) return null;

// //     // find month word (first word usually)
// //     const m = s.match(/([A-Za-z]{3,9})/);
// //     if (!m) return null;

// //     const monthWord = m[1].toLowerCase();
// //     const monthIdx = MONTHS[monthWord];
// //     if (monthIdx === undefined) return null;

// //     // find 4-digit year if any
// //     const y = s.match(/\b(20\d{2}|19\d{2})\b/);
// //     const year = y ? parseInt(y[1], 10) : (new Date()).getFullYear();

// //     return { monthIdx, year };
// //   }

// //   function monthKey({ monthIdx, year }) {
// //     return `${year}-${String(monthIdx + 1).padStart(2, '0')}`; // 2026-02
// //   }

// //   function monthLabel({ monthIdx, year }) {
// //     return `${MONTH_NAMES[monthIdx]} ${year}`; // Feb 2026
// //   }

// //   function readMonthsFacetValues() {
// //     const el = qs(MONTHS_JSON_SELECTOR);
// //     if (!el) return [];
// //     try {
// //       const arr = JSON.parse(el.textContent || '[]');
// //       return Array.isArray(arr) ? arr : [];
// //     } catch (e) {
// //       console.warn('[Months] JSON parse failed', e);
// //       return [];
// //     }
// //   }

// //   // Map: monthKey -> {label, year, monthIdx, items:[facetValueObjects], totalCount, anyActive, allDisabled}
// //   let monthGroups = new Map();

// //   function buildMonthGroups() {
// //     const values = readMonthsFacetValues();
// //     const groups = new Map();

// //     values.forEach(v => {
// //       const p = parseMonthYearFromLabel(v.label);
// //       if (!p) return;

// //       const key = monthKey(p);
// //       if (!groups.has(key)) {
// //         groups.set(key, {
// //           key,
// //           monthIdx: p.monthIdx,
// //           year: p.year,
// //           label: monthLabel(p),
// //           items: [],
// //           totalCount: 0,
// //           anyActive: false,
// //           allDisabled: true
// //         });
// //       }
// //       const g = groups.get(key);
// //       g.items.push(v);
// //       g.totalCount += Number(v.count || 0);
// //       g.anyActive = g.anyActive || !!v.active;
// //       g.allDisabled = g.allDisabled && !!v.disabled;
// //     });

// //     // Sort by year then month
// //     monthGroups = new Map(
// //       Array.from(groups.entries()).sort((a, b) => {
// //         const ga = a[1], gb = b[1];
// //         if (ga.year !== gb.year) return ga.year - gb.year;
// //         return ga.monthIdx - gb.monthIdx;
// //       })
// //     );
// //   }

// //   function renderMonthSelectOptions() {
// //     const select = qs(MONTH_SELECT_SELECTOR);
// //     if (!select) return;

// //     // Keep the first "All months" option, clear the rest
// //     const allOpt = select.querySelector('option[value=""]');
// //     select.innerHTML = '';
// //     if (allOpt) {
// //       select.appendChild(allOpt);
// //     } else {
// //       const o = document.createElement('option');
// //       o.value = '';
// //       o.textContent = 'All months';
// //       select.appendChild(o);
// //     }

// //     for (const [, g] of monthGroups) {
// //       const opt = document.createElement('option');
// //       opt.value = g.key;                 // <-- group key like 2026-02
// //       opt.dataset.groupKey = g.key;
// //       opt.textContent = `${g.label} (${g.totalCount})`;
// //       if (g.allDisabled && !g.anyActive) opt.disabled = true;
// //       select.appendChild(opt);
// //     }
// //   }

// //   function getMonthParamNameFromData() {
// //     const select = qs(MONTH_SELECT_SELECTOR);
// //     const fromSelect = select?.dataset?.paramName;
// //     return fromSelect || MONTH_PARAM_FALLBACK;
// //   }

// //   // Apply multi-select month group:
// //   // - Uncheck all currently checked months facet values
// //   // - Check all facet values belonging to the selected group key
// //   // function applyMonthGroup(groupKeyOrNull) {
// //   //   const paramName = getMonthParamNameFromData();

// //   //   // Clear current (all checked)
// //   //   const checked = getCheckedValues(paramName);
// //   //   checked.forEach(val => {
// //   //     const cb = findCheckbox(paramName, val);
// //   //     if (cb) clickLikeUser(cb);
// //   //   });

// //   //   if (!groupKeyOrNull) {
// //   //     scheduleSync();
// //   //     return;
// //   //   }

// //   //   const group = monthGroups.get(groupKeyOrNull);
// //   //   if (!group) {
// //   //     console.warn('[Months] Unknown group key', groupKeyOrNull);
// //   //     scheduleSync();
// //   //     return;
// //   //   }

// //   //   // Wait for re-render after clearing, then click all items in this month
// //   //   setTimeout(() => {
// //   //     group.items.forEach(item => {
// //   //       const cb = findCheckbox(item.param_name || paramName, item.value);
// //   //       if (cb && !cb.checked) clickLikeUser(cb);
// //   //     });
// //   //     scheduleSync();
// //   //   }, 120);
// //   // }

// //   // function applyMonthGroup(groupKeyOrNull) {
// //   //   // 1) Clear ALL currently checked month checkboxes (robust)
// //   //   //    Instead of only clearing getCheckedValues(paramName),
// //   //   //    we clear every active month value we know about from the JSON.
// //   //   const values = readMonthsFacetValues();

// //   //   values.forEach(v => {
// //   //     const name = v.param_name || getMonthParamNameFromData() || MONTH_PARAM_FALLBACK;
// //   //     const cb = findCheckbox(name, v.value);
// //   //     if (cb && cb.checked) clickLikeUser(cb);
// //   //   });

// //   //   // 2) If "All months" selected, stop after clearing
// //   //   if (!groupKeyOrNull) {
// //   //     scheduleSync();
// //   //     return;
// //   //   }

// //   //   const group = monthGroups.get(groupKeyOrNull);
// //   //   if (!group) {
// //   //     console.warn('[Months] Unknown group key', groupKeyOrNull);
// //   //     scheduleSync();
// //   //     return;
// //   //   }

// //   //   // 3) After Shopify re-renders from the clear, select the new month’s values
// //   //   setTimeout(() => {
// //   //     group.items.forEach(item => {
// //   //       const name = item.param_name || getMonthParamNameFromData() || MONTH_PARAM_FALLBACK;
// //   //       const cb = findCheckbox(name, item.value);
// //   //       if (cb && !cb.checked) clickLikeUser(cb);
// //   //     });

// //   //     scheduleSync();
// //   //   }, 120);
// //   // }

// //   function applyMonthGroup(groupKeyOrNull) {
// //     const allFacetItems = readMonthsFacetValues(); // [{param_name, value, ...}]
// //     const allValuesSet = new Set(allFacetItems.map(x => String(x.value)));

// //     // Current checked values (across ALL month param_names)
// //     const currentlyChecked = new Set(
// //       allFacetItems
// //         .filter(x => {
// //           const name = x.param_name || getMonthParamNameFromData() || MONTH_PARAM_FALLBACK;
// //           const cb = findCheckbox(name, x.value);
// //           return cb && cb.checked;
// //         })
// //         .map(x => String(x.value))
// //     );

// //     // Target values (empty = "All months")
// //     const targetValues = new Set();
// //     if (groupKeyOrNull) {
// //       const group = monthGroups.get(groupKeyOrNull);
// //       if (group) group.items.forEach(it => targetValues.add(String(it.value)));
// //     }

// //     // If "All months": uncheck everything (this will still result in all months, by definition)
// //     if (!groupKeyOrNull) {
// //       allFacetItems.forEach(x => {
// //         const name = x.param_name || getMonthParamNameFromData() || MONTH_PARAM_FALLBACK;
// //         const cb = findCheckbox(name, x.value);
// //         if (cb && cb.checked) clickLikeUser(cb);
// //       });
// //       scheduleSync();
// //       return;
// //     }

// //     // ---- DELTA (no "empty" moment) ----
// //     // 1) Uncheck those currently checked but not in target
// //     currentlyChecked.forEach(val => {
// //       if (!targetValues.has(val)) {
// //         // find item meta so we can locate checkbox (param_name may vary)
// //         const meta = allFacetItems.find(x => String(x.value) === val);
// //         const name = (meta?.param_name) || getMonthParamNameFromData() || MONTH_PARAM_FALLBACK;
// //         const cb = meta ? findCheckbox(name, meta.value) : null;
// //         if (cb && cb.checked) clickLikeUser(cb);
// //       }
// //     });

// //     // 2) Check those in target but not currently checked
// //     targetValues.forEach(val => {
// //       if (!currentlyChecked.has(val) && allValuesSet.has(val)) {
// //         const meta = allFacetItems.find(x => String(x.value) === val);
// //         const name = (meta?.param_name) || getMonthParamNameFromData() || MONTH_PARAM_FALLBACK;
// //         const cb = meta ? findCheckbox(name, meta.value) : null;
// //         if (cb && !cb.checked && !cb.disabled) clickLikeUser(cb);
// //       }
// //     });

// //     scheduleSync();
// //   }



// //   function syncMonthSelectFromFacetState() {
// //     const select = qs(MONTH_SELECT_SELECTOR);
// //     if (!select) return;

// //     const paramName = getMonthParamNameFromData();
// //     const checkedVals = new Set(getCheckedValues(paramName));

// //     // Determine which group is "active":
// //     // If any checked facet value belongs to a month group, select that group.
// //     // If multiple months are checked (possible), we’ll select blank (All months).
// //     let activeGroupKey = null;
// //     let activeCount = 0;

// //     for (const [, g] of monthGroups) {
// //       const anyCheckedInGroup = g.items.some(it => checkedVals.has(it.value));
// //       if (anyCheckedInGroup) {
// //         activeGroupKey = g.key;
// //         activeCount++;
// //         if (activeCount > 1) break;
// //       }
// //     }

// //     select.value = (activeCount === 1) ? activeGroupKey : '';
// //   }

// //   document.addEventListener('change', (e) => {
// //     const select = e.target.closest(MONTH_SELECT_SELECTOR);
// //     if (!select) return;

// //     const groupKey = select.value || null; // e.g. "2026-02" or null
// //     applyMonthGroup(groupKey);
// //   }, true);

// //   // ========= Init =========
// //   syncCategoryPillsFromFacetState();

// //   // Build months list from available values, then render grouped options
// //   buildMonthGroups();
// //   renderMonthSelectOptions();
// //   syncMonthSelectFromFacetState();

// //   // Rebuild months groups on grid changes (facets update)
// //   const obsRoot = qs('#ProductGridContainer') || document.body;
// //   const mo = new MutationObserver(() => {
// //     // Month values/counts/active can change after filtering; rebuild from JSON if it got re-rendered
// //     buildMonthGroups();
// //     renderMonthSelectOptions();
// //     scheduleSync();
// //   });
// //   mo.observe(obsRoot, { childList: true, subtree: true });
// // })();


// (() => {
//   // ========= CONFIG =========
//   const CATEGORY_GROUP_SELECTOR = '.custom-facets__pills[data-filter-label="Category"]';
//   const PILL_SELECTOR = '.custom-facet-pill';
//   const CLEAR_PILL_SELECTOR = '.custom-facet-pill--clear, .custom-facet-pill[data-clear="true"]';

//   const MONTH_SELECT_SELECTOR = '#CustomMonthSelect';
//   const MONTHS_JSON_SELECTOR = '#MonthsFacetValuesJSON';

//   const DRAWER_SELECTOR = 'facet-drawer#FacetDrawer';

//   const CATEGORY_PARAM = 'filter.p.m.custom.categry';
//   const MONTH_PARAM_FALLBACK = 'filter.p.m.custom.months';

//   const ACTIVE_CLASS = 'is-active';

//   const qs = (s, r = document) => r.querySelector(s);
//   const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
//   const drawer = qs(DRAWER_SELECTOR) || document;

//   const esc = (v) => (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, '\\$&');

//   // ========= Helpers =========
//   function clickLikeUser(cb) {
//     if (!cb) return;
//     const label = cb.id ? document.querySelector(`label[for="${esc(cb.id)}"]`) : null;
//     (label || cb).click();
//   }

//   function findCheckbox(name, value) {
//     const sel = `input[type="checkbox"][name="${esc(name)}"][value="${esc(value)}"]`;
//     return drawer.querySelector(sel) || document.querySelector(sel);
//   }

//   function getCheckboxes(name) {
//     return qsa(`input[type="checkbox"][name="${esc(name)}"]`, document);
//   }

//   function getCheckedValues(name) {
//     return getCheckboxes(name).filter(cb => cb.checked).map(cb => cb.value);
//   }

//   function getCheckedValue(name) {
//     const checked = getCheckboxes(name).find(cb => cb.checked);
//     return checked ? checked.value : null;
//   }

//   // ========= UI Sync (Category) =========
//   function syncCategoryPillsFromFacetState() {
//     const group = qs(CATEGORY_GROUP_SELECTOR);
//     if (!group) return;

//     const pills = qsa(PILL_SELECTOR, group).filter(p => !p.matches(CLEAR_PILL_SELECTOR));
//     const clearBtn = qs(CLEAR_PILL_SELECTOR, group);

//     const checkedValue = getCheckedValue(CATEGORY_PARAM);

//     pills.forEach(pill => {
//       const val = pill.dataset.value;
//       const isOn = !!checkedValue && val === checkedValue;
//       pill.classList.toggle(ACTIVE_CLASS, isOn);
//       pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
//     });

//     if (clearBtn) {
//       const showAllActive = !checkedValue;
//       clearBtn.classList.toggle(ACTIVE_CLASS, showAllActive);
//       clearBtn.setAttribute('aria-pressed', showAllActive ? 'true' : 'false');
//     }
//   }

//   // ========= Single-select CATEGORY =========
//   function setSingleCategoryValue(nextValueOrNull) {
//     const currentValue = getCheckedValue(CATEGORY_PARAM);

//     if (currentValue && nextValueOrNull === currentValue) {
//       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
//       if (currentCb) clickLikeUser(currentCb);
//       scheduleSync();
//       return;
//     }

//     if (currentValue) {
//       const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
//       if (currentCb) clickLikeUser(currentCb);
//     }

//     if (!nextValueOrNull) {
//       scheduleSync();
//       return;
//     }

//     setTimeout(() => {
//       const nextCb = findCheckbox(CATEGORY_PARAM, nextValueOrNull);
//       if (nextCb) clickLikeUser(nextCb);
//       scheduleSync();
//     }, 80);
//   }

//   document.addEventListener('click', (e) => {
//     const pill = e.target.closest(PILL_SELECTOR);
//     if (!pill) return;

//     const group = pill.closest(CATEGORY_GROUP_SELECTOR);
//     if (!group) return;

//     if (pill.matches(CLEAR_PILL_SELECTOR)) {
//       setSingleCategoryValue(null);
//       return;
//     }

//     setSingleCategoryValue(pill.dataset.value);
//   }, true);

//   // ==========================================================
//   // ===================== MONTH GROUPING ======================
//   // ==========================================================
//   const MONTHS = {
//     jan: 0, january: 0,
//     feb: 1, february: 1,
//     mar: 2, march: 2,
//     apr: 3, april: 3,
//     may: 4,
//     jun: 5, june: 5,
//     jul: 6, july: 6,
//     aug: 7, august: 7,
//     sep: 8, sept: 8, september: 8,
//     oct: 9, october: 9,
//     nov: 10, november: 10,
//     dec: 11, december: 11,
//   };
//   const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

//   function parseMonthYearFromLabel(label) {
//     const s = String(label || '').trim();
//     if (!s) return null;

//     const m = s.match(/([A-Za-z]{3,9})/);
//     if (!m) return null;

//     const monthWord = m[1].toLowerCase();
//     const monthIdx = MONTHS[monthWord];
//     if (monthIdx === undefined) return null;

//     const y = s.match(/\b(20\d{2}|19\d{2})\b/);
//     const year = y ? parseInt(y[1], 10) : (new Date()).getFullYear();

//     return { monthIdx, year };
//   }

//   function monthKey({ monthIdx, year }) {
//     return `${year}-${String(monthIdx + 1).padStart(2, '0')}`; // 2026-02
//   }

//   function monthLabel({ monthIdx, year }) {
//     return `${MONTH_NAMES[monthIdx]} ${year}`; // Feb 2026
//   }

//   function readMonthsFacetValues() {
//     const el = qs(MONTHS_JSON_SELECTOR);
//     if (!el) return [];
//     try {
//       const arr = JSON.parse(el.textContent || '[]');
//       return Array.isArray(arr) ? arr : [];
//     } catch (e) {
//       console.warn('[Months] JSON parse failed', e);
//       return [];
//     }
//   }

//   function getMonthParamNameFromData() {
//     const select = qs(MONTH_SELECT_SELECTOR);
//     return select?.dataset?.paramName || MONTH_PARAM_FALLBACK;
//   }

//   // Map: monthKey -> {label, year, monthIdx, items:[facetValueObjects], totalCount, anyActive}
//   let monthGroups = new Map();

//   function buildMonthGroups(values) {
//     const groups = new Map();

//     values.forEach(v => {
//       const p = parseMonthYearFromLabel(v.label);
//       if (!p) return;

//       const key = monthKey(p);
//       if (!groups.has(key)) {
//         groups.set(key, {
//           key,
//           monthIdx: p.monthIdx,
//           year: p.year,
//           label: monthLabel(p),
//           items: [],
//           totalCount: 0,
//           anyActive: false,
//         });
//       }
//       const g = groups.get(key);
//       g.items.push(v);
//       g.totalCount += Number(v.count || 0);
//       g.anyActive = g.anyActive || !!v.active;
//     });

//     monthGroups = new Map(
//       Array.from(groups.entries()).sort((a, b) => {
//         const ga = a[1], gb = b[1];
//         if (ga.year !== gb.year) return ga.year - gb.year;
//         return ga.monthIdx - gb.monthIdx;
//       })
//     );
//   }

//   // ---------- Prevent dropdown "blink" ----------
//   let monthSyncLockedUntil = 0;
//   function lockMonthSync(ms = 600) {
//     monthSyncLockedUntil = Date.now() + ms;
//   }
//   function monthSyncLocked() {
//     return Date.now() < monthSyncLockedUntil;
//   }

//   // Cache JSON so we only rebuild options when it truly changes
//   let lastMonthsJsonText = null;

//   function renderMonthSelectOptionsIfNeeded() {
//     const select = qs(MONTH_SELECT_SELECTOR);
//     const jsonEl = qs(MONTHS_JSON_SELECTOR);
//     if (!select || !jsonEl) return;

//     const jsonText = (jsonEl.textContent || '').trim();
//     if (jsonText === lastMonthsJsonText) {
//       // JSON unchanged -> do not rebuild options (prevents resets/blink)
//       updateMonthOptionDisabledStates();
//       return;
//     }
//     lastMonthsJsonText = jsonText;

//     // Preserve current selection
//     const prevValue = select.value;

//     // Rebuild groups from NEW JSON
//     const values = readMonthsFacetValues();
//     buildMonthGroups(values);

//     // Rebuild options
//     const hadAll = !!select.querySelector('option[value=""]');
//     select.innerHTML = '';
//     if (!hadAll) {
//       const o = document.createElement('option');
//       o.value = '';
//       o.textContent = 'All months';
//       select.appendChild(o);
//     } else {
//       const o = document.createElement('option');
//       o.value = '';
//       o.textContent = 'All months';
//       select.appendChild(o);
//     }

//     for (const [, g] of monthGroups) {
//       const opt = document.createElement('option');
//       opt.value = g.key;
//       opt.textContent = `${g.label} (${g.totalCount})`;
//       select.appendChild(opt);
//     }

//     // Restore selection if it still exists
//     const hasPrev = Array.from(select.options).some(o => o.value === prevValue);
//     select.value = hasPrev ? prevValue : '';

//     updateMonthOptionDisabledStates();
//   }

//   function updateMonthOptionDisabledStates() {
//     const select = qs(MONTH_SELECT_SELECTOR);
//     if (!select) return;

//     // Disable a group if NONE of its facet checkboxes exist+enabled in DOM.
//     // (Count from JSON can be stale during transitions; DOM is the truth.)
//     Array.from(select.options).forEach(opt => {
//       if (!opt.value) { opt.disabled = false; return; } // "All months"

//       const g = monthGroups.get(opt.value);
//       if (!g) { opt.disabled = true; return; }

//       const available = g.items.some(item => {
//         const name = item.param_name || getMonthParamNameFromData();
//         const cb = findCheckbox(name, item.value);
//         if (!cb) return false;
//         const ariaDisabled = cb.getAttribute('aria-disabled') === 'true';
//         return !cb.disabled && !ariaDisabled;
//       });

//       opt.disabled = !available;
//     });
//   }

//   // Delta apply (avoids empty moment)
//   function applyMonthGroup(groupKeyOrNull) {
//     const allFacetItems = readMonthsFacetValues();
//     const paramFallback = getMonthParamNameFromData();

//     const currentlyChecked = new Set(
//       allFacetItems
//         .filter(x => {
//           const name = x.param_name || paramFallback;
//           const cb = findCheckbox(name, x.value);
//           return cb && cb.checked;
//         })
//         .map(x => String(x.value))
//     );

//     const targetValues = new Set();
//     if (groupKeyOrNull) {
//       const group = monthGroups.get(groupKeyOrNull);
//       if (group) group.items.forEach(it => targetValues.add(String(it.value)));
//     }

//     // All months => uncheck everything (this can still show "All months", that's correct)
//     if (!groupKeyOrNull) {
//       allFacetItems.forEach(x => {
//         const name = x.param_name || paramFallback;
//         const cb = findCheckbox(name, x.value);
//         if (cb && cb.checked) clickLikeUser(cb);
//       });
//       scheduleSync();
//       return;
//     }

//     // Uncheck values not in target
//     currentlyChecked.forEach(val => {
//       if (!targetValues.has(val)) {
//         const meta = allFacetItems.find(x => String(x.value) === val);
//         const name = meta?.param_name || paramFallback;
//         const cb = meta ? findCheckbox(name, meta.value) : null;
//         if (cb && cb.checked) clickLikeUser(cb);
//       }
//     });

//     // Check missing target values
//     targetValues.forEach(val => {
//       if (!currentlyChecked.has(val)) {
//         const meta = allFacetItems.find(x => String(x.value) === val);
//         const name = meta?.param_name || paramFallback;
//         const cb = meta ? findCheckbox(name, meta.value) : null;
//         if (cb && !cb.checked && !cb.disabled) clickLikeUser(cb);
//       }
//     });

//     scheduleSync();
//   }

//   function syncMonthSelectFromFacetState() {
//     const select = qs(MONTH_SELECT_SELECTOR);
//     if (!select) return;
//     if (monthSyncLocked()) return; // <-- key: don't fight user selection during change

//     const paramName = getMonthParamNameFromData();
//     const checkedVals = new Set(getCheckedValues(paramName));

//     let activeGroupKey = null;
//     let activeCount = 0;

//     for (const [, g] of monthGroups) {
//       const anyCheckedInGroup = g.items.some(it => checkedVals.has(it.value));
//       if (anyCheckedInGroup) {
//         activeGroupKey = g.key;
//         activeCount++;
//         if (activeCount > 1) break;
//       }
//     }

//     select.value = (activeCount === 1) ? activeGroupKey : '';
//   }

//   // ========= Sync scheduling =========
//   function scheduleSync() {
//     setTimeout(() => {
//       syncCategoryPillsFromFacetState();
//       renderMonthSelectOptionsIfNeeded();
//       syncMonthSelectFromFacetState();
//     }, 80);

//     setTimeout(() => {
//       syncCategoryPillsFromFacetState();
//       renderMonthSelectOptionsIfNeeded();
//       syncMonthSelectFromFacetState();
//     }, 250);
//   }

//   // ========= Month change handler =========
//   document.addEventListener('change', (e) => {
//     const select = e.target.closest(MONTH_SELECT_SELECTOR);
//     if (!select) return;

//     // Lock sync so we don't set it to "" during transition
//     lockMonthSync(800);

//     const groupKey = select.value || null;
//     applyMonthGroup(groupKey);
//   }, true);

//   // ========= Init =========
//   syncCategoryPillsFromFacetState();

//   // Initial build from JSON
//   renderMonthSelectOptionsIfNeeded();
//   syncMonthSelectFromFacetState();

//   // Observe changes (Shopify rerenders sections)
//   const obsRoot = qs('#ProductGridContainer') || document.body;
//   const mo = new MutationObserver(() => {
//     // Only rebuild options if JSON changed (prevents dropdown reset)
//     renderMonthSelectOptionsIfNeeded();
//     scheduleSync();
//   });
//   mo.observe(obsRoot, { childList: true, subtree: true });
// })();


(() => {
  // ========= CONFIG =========
  const CATEGORY_GROUP_SELECTOR = '.custom-facets__pills[data-filter-label="Category"]';
  const PILL_SELECTOR = '.custom-facet-pill';
  const CLEAR_PILL_SELECTOR = '.custom-facet-pill--clear, .custom-facet-pill[data-clear="true"]';

  const MONTH_SELECT_SELECTOR = '#CustomMonthSelect';
  const MONTHS_JSON_SELECTOR = '#MonthsFacetValuesJSON';

  const DRAWER_SELECTOR = 'facet-drawer#FacetDrawer';

  const CATEGORY_PARAM = 'filter.p.m.custom.categry';
  const MONTH_PARAM_FALLBACK = 'filter.p.m.custom.months';

  const ACTIVE_CLASS = 'is-active';

  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const drawer = qs(DRAWER_SELECTOR) || document;

  const esc = (v) =>
    (window.CSS && CSS.escape)
      ? CSS.escape(String(v))
      : String(v).replace(/["\\]/g, '\\$&');

  // ========= Helpers =========
  function clickLikeUser(cb) {
    if (!cb) return;
    const label = cb.id ? document.querySelector(`label[for="${esc(cb.id)}"]`) : null;
    (label || cb).click();
  }

  function findCheckbox(name, value) {
    const sel = `input[type="checkbox"][name="${esc(name)}"][value="${esc(value)}"]`;
    return drawer.querySelector(sel) || document.querySelector(sel);
  }

  function getCheckboxes(name) {
    return qsa(`input[type="checkbox"][name="${esc(name)}"]`, document);
  }

  function getCheckedValues(name) {
    return getCheckboxes(name).filter(cb => cb.checked).map(cb => cb.value);
  }

  function getCheckedValue(name) {
    const checked = getCheckboxes(name).find(cb => cb.checked);
    return checked ? checked.value : null;
  }

  // ========= Disabled-state helpers (Category pills) =========
  function setPillDisabled(pillEl, disabled) {
    if (!pillEl) return;

    const isDisabled = !!disabled;
    pillEl.classList.toggle('is-disabled', isDisabled);
    pillEl.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

    // If pills are actual <button> elements, this will work
    if ('disabled' in pillEl) pillEl.disabled = isDisabled;

    // If pills are <a>/<div>, prevent interaction
    pillEl.style.pointerEvents = isDisabled ? 'none' : '';
    pillEl.style.opacity = isDisabled ? '0.5' : '';
  }

  function anyEnabledCheckboxForParam(name) {
    const cbs = getCheckboxes(name);
    return cbs.some(cb => {
      const ariaDisabled = cb.getAttribute('aria-disabled') === 'true';
      return !cb.disabled && !ariaDisabled;
    });
  }

  function isCategoryValueAvailable(value) {
    const cb = findCheckbox(CATEGORY_PARAM, value);
    if (!cb) return false;
    const ariaDisabled = cb.getAttribute('aria-disabled') === 'true';
    return !cb.disabled && !ariaDisabled;
  }

  // ========= UI Sync (Category) =========
  function syncCategoryPillsFromFacetState() {
    const group = qs(CATEGORY_GROUP_SELECTOR);
    if (!group) return;

    const pills = qsa(PILL_SELECTOR, group).filter(p => !p.matches(CLEAR_PILL_SELECTOR));
    const clearBtn = qs(CLEAR_PILL_SELECTOR, group);

    const checkedValue = getCheckedValue(CATEGORY_PARAM);

    // Regular pills: active + disabled state
    pills.forEach(pill => {
      const val = pill.dataset.value;

      // Disable pill if its matching checkbox is not available
      const available = isCategoryValueAvailable(val);
      setPillDisabled(pill, !available);

      const isOn = !!checkedValue && val === checkedValue;
      pill.classList.toggle(ACTIVE_CLASS, isOn);
      pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });

    // Clear/Show All pill: disable if nothing is available at all
    if (clearBtn) {
      const anyAvailable = anyEnabledCheckboxForParam(CATEGORY_PARAM);
      setPillDisabled(clearBtn, !anyAvailable);

      const showAllActive = !checkedValue;
      clearBtn.classList.toggle(ACTIVE_CLASS, showAllActive);
      clearBtn.setAttribute('aria-pressed', showAllActive ? 'true' : 'false');
    }
  }

  // ========= Single-select CATEGORY =========
  function setSingleCategoryValue(nextValueOrNull) {
    const currentValue = getCheckedValue(CATEGORY_PARAM);

    if (currentValue && nextValueOrNull === currentValue) {
      const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
      if (currentCb) clickLikeUser(currentCb);
      scheduleSync();
      return;
    }

    if (currentValue) {
      const currentCb = findCheckbox(CATEGORY_PARAM, currentValue);
      if (currentCb) clickLikeUser(currentCb);
    }

    if (!nextValueOrNull) {
      scheduleSync();
      return;
    }

    setTimeout(() => {
      const nextCb = findCheckbox(CATEGORY_PARAM, nextValueOrNull);
      if (nextCb) clickLikeUser(nextCb);
      scheduleSync();
    }, 80);
  }

  // Click handler (ignore disabled pills)
  document.addEventListener('click', (e) => {
    const pill = e.target.closest(PILL_SELECTOR);
    if (!pill) return;

    // If disabled, do nothing
    if (pill.getAttribute('aria-disabled') === 'true' || pill.classList.contains('is-disabled')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    const group = pill.closest(CATEGORY_GROUP_SELECTOR);
    if (!group) return;

    if (pill.matches(CLEAR_PILL_SELECTOR)) {
      setSingleCategoryValue(null);
      return;
    }

    setSingleCategoryValue(pill.dataset.value);
  }, true);

  // ==========================================================
  // ===================== MONTH GROUPING ======================
  // ==========================================================
  const MONTHS = {
    jan: 0, january: 0,
    feb: 1, february: 1,
    mar: 2, march: 2,
    apr: 3, april: 3,
    may: 4,
    jun: 5, june: 5,
    jul: 6, july: 6,
    aug: 7, august: 7,
    sep: 8, sept: 8, september: 8,
    oct: 9, october: 9,
    nov: 10, november: 10,
    dec: 11, december: 11,
  };
  const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function parseMonthYearFromLabel(label) {
    const s = String(label || '').trim();
    if (!s) return null;

    const m = s.match(/([A-Za-z]{3,9})/);
    if (!m) return null;

    const monthWord = m[1].toLowerCase();
    const monthIdx = MONTHS[monthWord];
    if (monthIdx === undefined) return null;

    const y = s.match(/\b(20\d{2}|19\d{2})\b/);
    const year = y ? parseInt(y[1], 10) : (new Date()).getFullYear();

    return { monthIdx, year };
  }

  function monthKey({ monthIdx, year }) {
    return `${year}-${String(monthIdx + 1).padStart(2, '0')}`; // 2026-02
  }

  function monthLabel({ monthIdx, year }) {
    return `${MONTH_NAMES[monthIdx]} ${year}`; // Feb 2026
  }

  function readMonthsFacetValues() {
    const el = qs(MONTHS_JSON_SELECTOR);
    if (!el) return [];
    try {
      const arr = JSON.parse(el.textContent || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      console.warn('[Months] JSON parse failed', e);
      return [];
    }
  }

  function getMonthParamNameFromData() {
    const select = qs(MONTH_SELECT_SELECTOR);
    return select?.dataset?.paramName || MONTH_PARAM_FALLBACK;
  }

  // Map: monthKey -> {label, year, monthIdx, items:[facetValueObjects], totalCount, anyActive}
  let monthGroups = new Map();

  function buildMonthGroups(values) {
    const groups = new Map();

    values.forEach(v => {
      const p = parseMonthYearFromLabel(v.label);
      if (!p) return;

      const key = monthKey(p);
      if (!groups.has(key)) {
        groups.set(key, {
          key,
          monthIdx: p.monthIdx,
          year: p.year,
          label: monthLabel(p),
          items: [],
          totalCount: 0,
          anyActive: false,
        });
      }
      const g = groups.get(key);
      g.items.push(v);
      g.totalCount += Number(v.count || 0);
      g.anyActive = g.anyActive || !!v.active;
    });

    monthGroups = new Map(
      Array.from(groups.entries()).sort((a, b) => {
        const ga = a[1], gb = b[1];
        if (ga.year !== gb.year) return ga.year - gb.year;
        return ga.monthIdx - gb.monthIdx;
      })
    );
  }

  // ---------- Prevent dropdown "blink" ----------
  let monthSyncLockedUntil = 0;
  function lockMonthSync(ms = 600) {
    monthSyncLockedUntil = Date.now() + ms;
  }
  function monthSyncLocked() {
    return Date.now() < monthSyncLockedUntil;
  }

  // Cache JSON so we only rebuild options when it truly changes
  let lastMonthsJsonText = null;

  function renderMonthSelectOptionsIfNeeded() {
    const select = qs(MONTH_SELECT_SELECTOR);
    const jsonEl = qs(MONTHS_JSON_SELECTOR);
    if (!select || !jsonEl) return;

    const jsonText = (jsonEl.textContent || '').trim();
    if (jsonText === lastMonthsJsonText) {
      // JSON unchanged -> do not rebuild options (prevents resets/blink)
      updateMonthOptionDisabledStates();
      return;
    }
    lastMonthsJsonText = jsonText;

    // Preserve current selection
    const prevValue = select.value;

    // Rebuild groups from NEW JSON
    const values = readMonthsFacetValues();
    buildMonthGroups(values);

    // Rebuild options
    select.innerHTML = '';

    const allOpt = document.createElement('option');
    allOpt.value = '';
    allOpt.textContent = 'All months';
    select.appendChild(allOpt);

    for (const [, g] of monthGroups) {
      const opt = document.createElement('option');
      opt.value = g.key;
      // opt.textContent = `${g.label} (${g.totalCount})`;
      opt.textContent = `${g.label}`;
      select.appendChild(opt);
    }

    // Restore selection if it still exists
    const hasPrev = Array.from(select.options).some(o => o.value === prevValue);
    select.value = hasPrev ? prevValue : '';

    updateMonthOptionDisabledStates();
  }

  function updateMonthOptionDisabledStates() {
    const select = qs(MONTH_SELECT_SELECTOR);
    if (!select) return;

    // Disable a group if NONE of its facet checkboxes exist+enabled in DOM.
    Array.from(select.options).forEach(opt => {
      if (!opt.value) { opt.disabled = false; return; } // "All months"

      const g = monthGroups.get(opt.value);
      if (!g) { opt.disabled = true; return; }

      const available = g.items.some(item => {
        const name = item.param_name || getMonthParamNameFromData();
        const cb = findCheckbox(name, item.value);
        if (!cb) return false;
        const ariaDisabled = cb.getAttribute('aria-disabled') === 'true';
        return !cb.disabled && !ariaDisabled;
      });

      opt.disabled = !available;
    });
  }

  // Delta apply (avoids empty moment)
  function applyMonthGroup(groupKeyOrNull) {
    const allFacetItems = readMonthsFacetValues();
    const paramFallback = getMonthParamNameFromData();

    const currentlyChecked = new Set(
      allFacetItems
        .filter(x => {
          const name = x.param_name || paramFallback;
          const cb = findCheckbox(name, x.value);
          return cb && cb.checked;
        })
        .map(x => String(x.value))
    );

    const targetValues = new Set();
    if (groupKeyOrNull) {
      const group = monthGroups.get(groupKeyOrNull);
      if (group) group.items.forEach(it => targetValues.add(String(it.value)));
    }

    // All months => uncheck everything
    if (!groupKeyOrNull) {
      allFacetItems.forEach(x => {
        const name = x.param_name || paramFallback;
        const cb = findCheckbox(name, x.value);
        if (cb && cb.checked) clickLikeUser(cb);
      });
      scheduleSync();
      return;
    }

    // Uncheck values not in target
    currentlyChecked.forEach(val => {
      if (!targetValues.has(val)) {
        const meta = allFacetItems.find(x => String(x.value) === val);
        const name = meta?.param_name || paramFallback;
        const cb = meta ? findCheckbox(name, meta.value) : null;
        if (cb && cb.checked) clickLikeUser(cb);
      }
    });

    // Check missing target values
    targetValues.forEach(val => {
      if (!currentlyChecked.has(val)) {
        const meta = allFacetItems.find(x => String(x.value) === val);
        const name = meta?.param_name || paramFallback;
        const cb = meta ? findCheckbox(name, meta.value) : null;
        if (cb && !cb.checked && !cb.disabled) clickLikeUser(cb);
      }
    });

    scheduleSync();
  }

  function syncMonthSelectFromFacetState() {
    const select = qs(MONTH_SELECT_SELECTOR);
    if (!select) return;
    if (monthSyncLocked()) return; // don't fight user selection during change

    const paramName = getMonthParamNameFromData();
    const checkedVals = new Set(getCheckedValues(paramName));

    let activeGroupKey = null;
    let activeCount = 0;

    for (const [, g] of monthGroups) {
      const anyCheckedInGroup = g.items.some(it => checkedVals.has(it.value));
      if (anyCheckedInGroup) {
        activeGroupKey = g.key;
        activeCount++;
        if (activeCount > 1) break;
      }
    }

    select.value = (activeCount === 1) ? activeGroupKey : '';
  }

  // ========= Sync scheduling =========
  function scheduleSync() {
    setTimeout(() => {
      syncCategoryPillsFromFacetState();
      renderMonthSelectOptionsIfNeeded();
      syncMonthSelectFromFacetState();
    }, 80);

    setTimeout(() => {
      syncCategoryPillsFromFacetState();
      renderMonthSelectOptionsIfNeeded();
      syncMonthSelectFromFacetState();
    }, 250);
  }

  // ========= Month change handler =========
  document.addEventListener('change', (e) => {
    const select = e.target.closest(MONTH_SELECT_SELECTOR);
    if (!select) return;

    // Lock sync so we don't set it to "" during transition
    lockMonthSync(800);

    const groupKey = select.value || null;
    applyMonthGroup(groupKey);
  }, true);

  // ========= Init =========
  syncCategoryPillsFromFacetState();

  // Initial build from JSON
  renderMonthSelectOptionsIfNeeded();
  syncMonthSelectFromFacetState();

  // Observe changes (Shopify rerenders sections)
  const obsRoot = qs('#ProductGridContainer') || document.body;
  const mo = new MutationObserver(() => {
    renderMonthSelectOptionsIfNeeded();
    scheduleSync();
  });
  mo.observe(obsRoot, { childList: true, subtree: true });
})();
